import React from 'react';
import FeatureProduct from './Components/FeatureProduct';
import Footer from './Components/Footer';
import HeroSection from './Components/HeroSection';
import Services from './Components/Services';
import Trusted from './Components/Trusted';
const Home = () => {
    const data = {
        name: "Rahul store",
      };
  return (
    <div>
       <HeroSection myData={data} />
       <FeatureProduct/>
       <Services/>
       <Trusted/>
       <Footer/>
       
    </div>
  );
}

export default Home;
